import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import MaterialTable from "material-table";
import {
  showNotification,
  withDataProvider,
  Loading,
  GET_LIST
} from "react-admin";
import { formatNumber } from "../../utils/formating";

const styles = {};

class StockList extends Component {
  state = { loadingListStock: false, dataStock: null };

  getData = () => {
    const { dataProvider, dispatch } = this.props;
    dataProvider(GET_LIST, "products/get/list/stock", null)
      .then(({ data }) => {
        const dataStock = data;
        dataProvider(GET_LIST, "products/get/list/complete", null)
          .then(({ data }) => {
            let stockList = [], prod;
            /**
             * filter stock prods with the complete prod list
             * the complete API filter discontinued products
             */
            dataStock.forEach(stockElem => {
              for (let i = 0; i < data.length; i++) {
                prod = data[i];
                if (stockElem.productId === prod.productId) {
                  stockList.push(stockElem);
                  break;
                }
              }
            });
            this.setState({ loadingListStock: true, dataStock: stockList });
          })
          .catch(error => {
            dispatch(showNotification(error.message, "error"));
          });

      })
      .catch(error => {
        dispatch(showNotification(error.message, "error"));
      });
  };

  componentDidMount() {
    this.getData();
  }

  render() {
    const { loadingListStock, dataStock } = this.state;
    return loadingListStock ? (
      <MaterialTable
        tableRef={this.tableRef}
        options={{
          pageSize: 10
        }}
        columns={[
          { title: "ID", field: "productId" },
          { title: "Código", field: "code" },
          { title: "Stock", field: "stock", render: rowData => formatNumber(rowData.stock) }
        ]}
        data={dataStock}
        title="Listado de Stock"
      />
    ) : (
      <Loading />
    );
  }
}

export default withStyles(styles)(withDataProvider(StockList));
